import { z } from 'zod';
import { useCallback } from 'react';
import { useApi, fetchApiRef } from '@backstage/frontend-plugin-api';
import { trackHistoryResponseSchema } from '../schemas/tracks';
import {
  PULSE_CACHE_KEYS,
  PULSE_QUERY_CACHE_POLICIES,
  useCachedQuery,
} from './cache';

export type TrackHistoryPoint = z.infer<
  typeof trackHistoryResponseSchema
>['history'][number];

export const useTrackHistory = (trackId: string, days: number) => {
  const fetchApi = useApi(fetchApiRef);

  const fetchHistory = useCallback(async () => {
    const response = await fetchApi.fetch(
      `plugin://pulse/tracks/${encodeURIComponent(
        trackId,
      )}/history?days=${days}`,
    );

    if (!response.ok) {
      throw new Error(
        `Failed to fetch track history: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    const parsed = trackHistoryResponseSchema.parse(data);
    return parsed.history;
  }, [trackId, days, fetchApi]);

  return useCachedQuery({
    cacheKey: PULSE_CACHE_KEYS.trackHistory(trackId, days),
    fetcher: fetchHistory,
    ...PULSE_QUERY_CACHE_POLICIES.history,
  });
};
